module.exports = __webpack_public_path__ + "785bb0447ebb65fbe3e20713c3b80949.fbx";